const Types = {
	TEMPLATES_ADD: "TEMPLATES_ADD",
	TEMPLATES_UPDATE_FIELD: "TEMPLATES_UPDATE_FIELD",
};

const addTemplate = () => ({
	type: Types.TEMPLATES_ADD,
});

const updateTemplate = (id, field, newValue) => ({
	type: Types.TEMPLATES_UPDATE_FIELD,
	id,
	field,
	newValue,
});

const Actions = {
	addTemplate,
	updateTemplate,
};

export { Actions, Types };
